import { useState, useCallback, useRef } from 'react';

export function useCircuitData() {
  const [circuitTemples, setCircuitTemples] = useState(null);
  const [loading, setLoading]               = useState(false);
  const [error, setError]                   = useState(null);
  const cache                               = useRef({});

  const loadCircuit = useCallback(async (circuit, statesIndex) => {
    setLoading(true);
    setError(null);
    setCircuitTemples(null);
    try {
      const results = await Promise.all(
        circuit.states.map(async (stateId) => {
          if (cache.current[stateId]) return cache.current[stateId];
          const info = statesIndex.find(s => s.id === stateId);
          if (!info) return { data: [], info: { name_en: stateId, name_hi: stateId } };
          const res  = await fetch(`${process.env.PUBLIC_URL}/data/${info.file}`);
          if (!res.ok) throw new Error(`Failed to load ${info.file} (${res.status})`);
          const json = await res.json();
          const data = Array.isArray(json) ? json : json.temples;
          const entry = { data, info };
          cache.current[stateId] = entry;
          return entry;
        })
      );
      const all = results.flatMap(({ data, info }) =>
        data.map(t => ({ ...t, _stateName: info.name_en, _stateNameHi: info.name_hi }))
      );
      setCircuitTemples(all.filter(circuit.match));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearCircuit = useCallback(() => {
    setCircuitTemples(null);
    setError(null);
  }, []);

  return { circuitTemples, loading, error, loadCircuit, clearCircuit };
}
